import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

type MessageKey =
  | 'completedFormMessage'
  | 'completedFileRequestMessage'
  | 'goToMyAccount';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  completedFormMessage: {
    id: 'boxFileRequest.completedForm.FormMessage',
    description: 'Message displayed on successful form submission',
    defaultMessage: 'Success! Your form has been submitted.',
  },

  completedFileRequestMessage: {
    id: 'boxFileRequest.completedForm.FileRequestMessage',
    description: 'Message displayed on successful file request submission',
    defaultMessage: `{numFiles, plural,
      one {Success! Your file has been submitted.}
      other {Success! Your files have been submitted.}
    }`,
  },

  goToMyAccount: {
    id: 'boxFileRequest.completedForm.goToMyAccount',
    description: 'Button label for Go to My Account',
    defaultMessage: 'Go to My Account',
  },
});

export default messages;
